import { BaseStorage } from '@golden/utils';
export class VersionTagStorage extends BaseStorage {
    get versionTag() {
        if (!this.driver.exist(this.VERSION_TAG)) {
            return null;
        }
        return this.driver.get(this.VERSION_TAG);
    }
    set versionTag(value) {
        if (value)
            this.driver.set(this.VERSION_TAG, value);
        else
            this.driver.remove(this.VERSION_TAG);
    }
    static getInstance() {
        return super.getInstance();
    }
    prefix = 'VersionTag';
    VERSION_TAG = 'VERSION_TAG';
}
//# sourceMappingURL=VersionTagStorage.js.map